export const aiWrite = {
  contextMenu: {
    freeUserIcon: 'crown---circle---yellow',
    proUserIcon: 'stars-add---square'
  }
};
